<div class="confirmation-wrapper">
  <!-- NEW: Centered Success View -->
  <div class="confirmation-container">
    <!-- Success Icon -->
    <div class="success-icon">
      <i class="fa-solid fa-check"></i>
    </div>

    <!-- Main Title -->
    <h1 class="main-title">Ride Request Received!</h1>
    <p class="subtitle">
      Always Ready With Shiv Sewa. Someone from our team will contact you shortly.
    </p>

    <!-- Booking Details Card -->
    <div class="booking-details-card">
      <!-- Reference and Date Row -->
      <div class="info-row">
        <div class="info-item">
          <div class="info-label">BOOKING REFERENCE</div>
          <div class="info-value">#{{ booking?.bookingRef || '782082313' }}</div>
        </div>
        <div class="info-item text-right">
          <div class="info-label">DATE</div>
          <div class="info-value">
              {{ booking?.date | date:'MMMM' }}
            {{ (booking?.date | date:'d')! | ordinal }},
            {{ booking?.date | date:'yyyy' }}
          </div>
        </div>
      </div>

      <!-- Details List -->
      <!-- Fare Breakdown (Same UI Style) -->
      <div class="details-list mt-3" *ngIf="booking?.fareQuote as fare">

  <!-- ================= HEADER ================= -->
  <div class="detail-row">
    <span class="detail-label fw-bold">Fare Breakup:</span>
    <span class="detail-value"></span>
  </div>

  <!-- ================= PICKUP & DROP ================= -->
  <ng-container *ngIf="fare.tripType === 'pickup_drop'">

    <div class="detail-row">
      <span class="detail-label">
        Base Fare
        <small>(Includes base km)</small>
      </span>
      <span class="detail-value">
        ₹{{ fare.lines[0]?.amount | number:'1.0-2' }}
      </span>
    </div>

    <div
      class="detail-row"
      *ngFor="let line of fare.lines"
      [hidden]="line.code !== 'EXTRA_KM'"
    >
      <span class="detail-label">
        Extra Distance
        <small>
          ({{ line.qty | number:'1.2-2' }} km × ₹{{ line.unitPrice }})
        </small>
      </span>
      <span class="detail-value">
        ₹{{ line.amount | number:'1.0-2' }}
      </span>
    </div>

  </ng-container>

  <!-- ================= RENTAL ================= -->
  <ng-container *ngIf="fare.tripType === 'rental'">

    <div class="detail-row" *ngFor="let line of fare.lines">
      <span class="detail-label">
        {{ line.label }}
        <small *ngIf="line.code !== 'PACKAGE'">
          ({{ line.qty | number:'1.2-2' }} × ₹{{ line.unitPrice }})
        </small>
      </span>
      <span class="detail-value">
        ₹{{ line.amount | number:'1.0-2' }}
      </span>
    </div>

  </ng-container>

  <!-- ================= OUTSTATION ================= -->
  <ng-container *ngIf="fare.tripType === 'outstation'">

    <div class="detail-row text-muted">
      <span class="detail-label">
        Minimum distance per day rule applies
      </span>
      <span class="detail-value"></span>
    </div>

    <div class="detail-row">
      <span class="detail-label">Actual Distance</span>
      <span class="detail-value">
        {{ fare.distanceKm | number:'1.2-2' }} km
      </span>
    </div>

    <div class="detail-row">
      <span class="detail-label">
        Billable Distance
        <small>(Higher of actual or minimum per-day)</small>
      </span>
      <span class="detail-value">
        {{ fare.lines[0]?.qty | number:'1.2-2' }} km
      </span>
    </div>

    <div class="detail-row">
      <span class="detail-label">
        Distance Charge
        <small>
          ({{ fare.lines[0]?.qty | number:'1.2-2' }} km × ₹{{ fare.lines[0]?.unitPrice }})
        </small>
      </span>
      <span class="detail-value">
        ₹{{ fare.lines[0]?.amount | number:'1.0-2' }}
      </span>
    </div>

    <div class="detail-row">
      <span class="detail-label">
        Driver Allowance
        <small>
          ({{ fare.lines[1]?.qty }} day × ₹{{ fare.lines[1]?.unitPrice }})
        </small>
      </span>
      <span class="detail-value">
        ₹{{ fare.lines[1]?.amount | number:'1.0-2' }}
      </span>
    </div>

  </ng-container>

  <!-- ================= SUB TOTAL ================= -->
  <div class="detail-row" *ngIf="booking?.pricing?.baseAmount">
    <span class="detail-label fw-bold">Sub Total:</span>
    <span class="detail-value">
      ₹{{ booking?.pricing?.baseAmount | number:'1.0-2' }}
    </span>
  </div>

  <!-- ================= TAX ================= -->
  <div
    class="detail-row"
    *ngIf="booking?.pricing?.taxPercentage && booking?.pricing?.taxAmount"
  >
    <span class="detail-label">
      GST ({{ booking.pricing.taxPercentage }}%)
    </span>
    <span class="detail-value">
      ₹{{ booking.pricing.taxAmount | number:'1.0-2' }}
    </span>
  </div>

  <!-- ================= TOTAL ================= -->
  <div
    class="detail-row fw-bold"
    *ngIf="booking?.pricing?.totalAmount"
  >
    <span class="detail-label">Total Estimated Fare:</span>
    <span class="detail-value fare-value">
      ₹{{ booking.pricing.totalAmount | number:'1.0-2' }}
    </span>
  </div>

</div>



      <!-- Disclaimer -->
      <p class="disclaimer">
        * Final fare may change depending on actual distance covered, waiting time, or route deviations.
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-secondary" (click)="goBack()">
        Back to Home
      </button>
      <button class="btn btn-primary" (click)="loadMap()">
        View Route on Map
      </button>
    </div>

      <div class="next-section">
    <h5>What Happens Next?</h5>
    <ul>
      <li>
        <strong>Chauffeur Allocation:</strong> We're assigning one of our
        top-rated chauffeurs for your trip.
      </li>
      <li>
        Your driver details will be shared via email & WhatsApp 1 hour before
        pickup.
      </li>
      <li>
        Simply pay your chauffeur at the end of the trip. Cash, UPI, and Card
        are accepted.
      </li>
    </ul>
  </div>
  </div>

  <!-- EXISTING: Map Modal (Hidden Initially) -->
  <div class="map-modal" *ngIf="mapLoaded" (click)="closeMap()">
    <div class="map-modal-content" (click)="$event.stopPropagation()">
      <button class="close-map-btn" (click)="closeMap()">
        <i class="fa-solid fa-times"></i>
      </button>

      <div class="map-header">
        <h3>Your Route</h3>
        <p>{{ booking?.pickup?.name }} to {{ booking?.dropoff?.name }}</p>
      </div>

      <div class="map-wrapper">
        <!-- Distance Info -->
        <div class="map-info">
          <i class="fa-solid fa-route"></i>
          <span>{{ distanceText }}</span>
          <span>•</span>
          <span>{{ durationText }}</span>
        </div>

        <!-- Real Google Map -->
        <div
          id="routeMap"
          class="route-map"
          (click)="openInGoogleMaps()"
        ></div>
      </div>

      <button class="open-gmaps-btn" (click)="openInGoogleMaps()">
        <i class="fa-solid fa-external-link-alt"></i>
        Open in Google Maps
      </button>
    </div>
  </div>

  <!-- EXISTING: What Happens Next Section -->

</div>
